import React from 'react'

export const ConfirmRsvp = React.lazy(
  () => import(/* webpackChunkName: "confirm-rsvp-modal" */ '../modals/confirm-rsvp'),
)
